import React, { useState } from 'react';
import {
    Box,
    Button,
    FormControl,
    FormLabel,
    Input,
    Textarea,
    Stack,
    useToast,
} from '@chakra-ui/react';
import { createGoal } from "../../../data/Goals";
import { useAuth } from '../../../contexts/AuthContext';

/**
 * Goal creation form
 * Collects title, description, and target date
 */
export default function GoalForm({ onSuccess }) {
    const toast = useToast();
    const { user } = useAuth();

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [targetDate, setTargetDate] = useState(new Date().toISOString().split('T')[0]);
    const [isSaving, setIsSaving] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);

        const payload = {
            profile_id: user.id,
            title,
            description,
            status: 'active',
            target_date: targetDate,
        };

        const { data, error } = await createGoal(payload);
        setIsSaving(false);

        if (error) {
            toast({
                title: 'Error creating goal',
                description: error.message,
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        } else {
            toast({
                title: 'Goal created',
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
            onSuccess && onSuccess(data);
        }
    };

    return (
        <Box as="form" onSubmit={handleSubmit} p={4} bg="white" rounded="md" shadow="sm">
            <Stack spacing={4}>
                <FormControl isRequired>
                    <FormLabel>Title</FormLabel>
                    <Input
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="e.g. Launch new feature"
                    />
                </FormControl>

                <FormControl>
                    <FormLabel>Description</FormLabel>
                    <Textarea
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Optional details"
                    />
                </FormControl>

                <FormControl isRequired>
                    <FormLabel>Target Date</FormLabel>
                    <Input
                        type="date"
                        value={targetDate}
                        onChange={(e) => setTargetDate(e.target.value)}
                    />
                </FormControl>

                <Button colorScheme="blue" type="submit" isLoading={isSaving}>
                    Save Goal
                </Button>
            </Stack>
        </Box>
    );
}
